import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { createPortal } from "react-dom";
import classNames from "classnames";
import {
  Dropdown as ReactstrapDropdown,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { noop } from "@helpers/common";

import styles from "./index.module.scss";

const Dropdown = (
  {
    disabled,
    children,
    toggler,
    end,
    caret,
    flip = false,
    onOpen,
    onClose,
    menuClassName,
    togglerClassName,
    wrapperClassName,
    direction,
    isTourRunning,
    onTouchEnd = noop,
    onTouchStart = noop,
    usePortal = false,
    doNotUseStopPropagation = false,
  },
  ref,
) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen((state) => !state);

  useEffect(() => {
    if (isOpen) {
      return onOpen?.();
    }
    onClose?.();
  }, [isOpen, onOpen, onClose]);

  useImperativeHandle(ref, () => ({
    setIsOpen,
  }));

  return (
    <ReactstrapDropdown
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
      direction={direction}
      toggle={isTourRunning ? () => {} : toggle}
      isOpen={isTourRunning || isOpen}
      disabled={disabled}
      className={wrapperClassName}
    >
      <DropdownToggle
        caret={caret}
        onClick={(e) => {
          if (doNotUseStopPropagation) return;
          e?.stopPropagation();
        }}
        disabled={disabled}
        className={classNames(
          "d-flex align-items-center justify-content-center",
          styles.dropdownToggle,
          togglerClassName,
        )}
      >
        {toggler}
      </DropdownToggle>
      {usePortal ? (
        createPortal(
          <DropdownMenu
            className={classNames(styles.dropdownOpen, menuClassName)}
            end={end}
            flip={flip}
          >
            {children}
          </DropdownMenu>,
          document.body,
        )
      ) : (
        <DropdownMenu
          className={classNames(styles.dropdownOpen, menuClassName)}
          end={end}
          flip={flip}
        >
          {children}
        </DropdownMenu>
      )}
    </ReactstrapDropdown>
  );
};

export default forwardRef(Dropdown);
